document.addEventListener("DOMContentLoaded", function () {
  const containerObserver = new MutationObserver((mutations) => {
    const bundlesContainer = document.querySelector("#rbr-container-element-false");
    const addonsContainer = document.querySelector("#rbr-container-element-addOn");
    if (bundlesContainer || addonsContainer) {
      containerObserver.disconnect();
      const bundlesObserver = new MutationObserver((mutations) => {
        let bundles = bundlesContainer
          ? Array.from(bundlesContainer.querySelectorAll('[id^="rbr-bundle-"]'))
          : [];
        let addons = addonsContainer
          ? Array.from(addonsContainer.querySelectorAll('[id^="rbr-bundle-"]'))
          : [];
        if (bundles.length > 0 || addons.length > 0) {
          bundlesObserver.disconnect();
          (async () => {
            try {
              await new Promise((resolve) => setTimeout(resolve, 500));
              bundles = bundlesContainer
                ? Array.from(bundlesContainer.querySelectorAll('[id^="rbr-bundle-"]'))
                : [];
              addons = addonsContainer
                ? Array.from(addonsContainer.querySelectorAll('[id^="rbr-bundle-"]'))
                : [];
              if (bundles.length > 0) {
                removeSoldOutBundles(bundles);
                setBundlesTitle(bundlesContainer);
                await setBundleImage(bundles);
                adjustExpandedBundle(bundles);
                adjustBundleTotalsAndBadges(bundles);
                bundlesContainer.classList.add("loaded");
                removeSpinner(bundlesContainer);
              } else if (addons.length > 0) {
                removeSoldOutAddons(addons);
                setAddonsTitle(addonsContainer);
                addonsContainer.classList.add("loaded");
                removeSpinner(addonsContainer);
              }
            } catch (error) {
              console.error("Error processing bundles:", error);
            }
          })();
        }
      });
      bundlesObserver.observe(bundlesContainer || addonsContainer, {
        childList: true,
        subtree: true,
      });
    }
  });
  containerObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  function removeSoldOutAddons(addons) {
    addons.forEach((addon) => {
      const addonItems = addon.querySelectorAll(".style_container_1d94a93b");
      addonItems.forEach((addonItem) => {
        const addonSoldOutBadge = addonItem.querySelector(".style_badge_1d94a93b");
        if (addonSoldOutBadge && addonSoldOutBadge.textContent.includes("Sold out")) {
          addonItem.remove();
        }
      });
    });
  }

  function setAddonsTitle(addonsContainer) {
    const addonsOnPageTitle = addonsContainer.querySelector(".style_titleAndBadge_503fc477");
    if (addonsOnPageTitle && addonsOnPageTitle.textContent !== "") {
      const titleText = addonsOnPageTitle.textContent;
      const newTitle = document.createElement("h2");
      newTitle.textContent = titleText;
      addonsOnPageTitle.parentNode.replaceChild(newTitle, addonsOnPageTitle);
    } else {
      const addonsTitleDiv = addonsContainer.querySelector(".style_header_503fc477");
      const addonsTitle = document.createElement("h2");
      addonsTitle.textContent = window.addonsTitle;
      addonsTitleDiv.prepend(addonsTitle);
    }
  }

  function setBundlesTitle(bundlesContainer) {
    const bundlesTitle = document.createElement("h2");
    bundlesTitle.classList.add("bundles-title");
    bundlesTitle.textContent = window.bundlesTitle;
    bundlesContainer.prepend(bundlesTitle);
  }

  function removeSoldOutBundles(bundles) {
    bundles.forEach((bundle) => {
      const bundleAddToCart = bundle.querySelector(".rbr-addBundleBtn-container");
      if (bundleAddToCart.classList.contains("rbr-disable")) {
        bundle.remove();
      }
    });
  }

  function removeSpinner(container) {
    container.classList.add("loaded");
    const spinner = document.querySelector(".upsells-spinner");
    if (spinner) {
      spinner.remove();
    }
  }

  function adjustExpandedBundle(bundles) {
    const bundlesTitles = document.querySelectorAll(".rbr-standard-bundle__title");
    bundlesTitles.forEach((title) => {
      title.addEventListener("click", () => {
        title.classList.toggle("expanded");
      });
    });
  }
  async function setBundleImage(bundles) {
    const promises = bundles.map(async (bundle) => {
      try {
        const bundleTitle = bundle.querySelector(".rbr-standard-bundle__title span").textContent;

        const response = await fetch("https://bundleimage-j4htuymeaq-uc.a.run.app", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productTitle: bundleTitle,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch bundle image: ${response.status}`);
        }

        const data = await response.json();
        const bundleImage = document.createElement("img");
        bundleImage.src = data.imageUrl;
        bundleImage.classList.add("rbr-standard-bundle__title-image");
        bundleImage.onerror = () => {
          console.warn(`Failed to load image for bundle: ${bundleTitle}`);
          bundleImage.remove();
        };
        bundle.querySelector(".rbr-standard-bundle__title").prepend(bundleImage);
      } catch (error) {
        console.error("Error setting bundle image:", error);
      }
    });

    await Promise.allSettled(promises);
  }
  function adjustBundleTotalsAndBadges(bundles) {
    bundles.forEach((bundle) => {
      const bundleTotal =
        bundle.querySelector(".rbr-totalBox-container") ||
        bundle.querySelector(".rbr-addBundleBtn-container");
      const bundleAddToCartSpan = bundle.querySelector(".rbr-addBundleBtn-container span");
      if (bundleTotal && bundleAddToCartSpan) {
        const rawPrice = bundle.querySelector(".rbr-total-box-rawPrice .money");
        const regularPrice = bundle.querySelector(".rbr-total-box-price .money");
        if (rawPrice && regularPrice) {
          rawPrice.classList.add("rbr-total-box-rawPrice");
          bundleAddToCartSpan.textContent += " - ";
          bundleAddToCartSpan.appendChild(regularPrice);
          bundleAddToCartSpan.appendChild(document.createElement("span")).textContent = " ";
          bundleAddToCartSpan.appendChild(rawPrice);
          const rawPriceValue = parseFloat(rawPrice.textContent.replace("$", "").replace(",", ""));
          const regularPriceValue = parseFloat(
            regularPrice.textContent.replace("$", "").replace(",", "")
          );
          const saleAmount = rawPriceValue - regularPriceValue;
          const discountPercentage = Math.round((saleAmount / rawPriceValue) * 100);
          const saleBadge = document.createElement("div");
          const bundleTitle = bundle.querySelector(".rbr-standard-bundle__title");
          const bundleTitlesSpan = bundleTitle.querySelector("span");
          saleBadge.classList.add("rbr-sale-badge");
          saleBadge.textContent = `Save ${discountPercentage}%`;
          bundleTitle.prepend(saleBadge);
        } else if (regularPrice) {
          bundleAddToCartSpan.textContent += " - ";
          bundleAddToCartSpan.appendChild(regularPrice);
        }
      }
    });
  }
});
